/**
 * Languages supported by LumApps.
 * Intentionally CommonJS with no browser API references — safe to require from Node.js tooling.
 */

const defaultSupportedLanguages = [
    'ar',
    'az',
    'bg',
    'cs',
    'de',
    'el',
    'en',
    'es',
    'fr',
    'fr_ca',
    'hi',
    'hr',
    'hu',
    'it',
    'is',
    'ja',
    'ko',
    'ku',
    'nl',
    'no',
    'pl',
    'pt',
    'pt_br',
    'ro',
    'ru',
    'sk',
    'sl',
    'sr',
    'sv',
    'th',
    'tl',
    'tr',
    'uk',
    'vi',
    'zh',
    'zh_hk',
    'zh_tw',
];

module.exports = { defaultSupportedLanguages };
